import { Button as ReshapedButton } from "reshaped";

import {
    type Action,
    getActionAnchorProps,
    getActionButtonProps,
    getActionClickableProps,
} from "../../action/Action";
import { buttonSize, feelingColor, roleVariant } from "./constants";
import type { ButtonFeeling, ButtonRole, ButtonSize } from "./types";

type ButtonProps = {
    label: string;
    action: Action;
    feeling?: ButtonFeeling;
    role?: ButtonRole;
    size?: ButtonSize;
};

export default function Button(props: ButtonProps) {
    const { feeling = "normal", role = "main", action, label, size = "normal" } = props;
    const anchorProps = getActionAnchorProps(action);
    const clickableProps = getActionClickableProps(action);
    const buttonProps = getActionButtonProps(action);
    const color = feelingColor[feeling];
    const variant = roleVariant[role];
    const r_size = buttonSize[size];
    return (
        <ReshapedButton
            {...anchorProps}
            {...clickableProps}
            {...buttonProps}
            color={color}
            variant={variant}
            size={r_size}
        >
            {label}
        </ReshapedButton>
    );
}
